import script from "./PCPartsDetailsCardMainBodySecondaryActions.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsDetailsCardMainBodySecondaryActions.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsDetailsCardMainBodySecondaryActions.vue?vue&type=style&index=0&id=bd7909aa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd7909aa"]])

export default __exports__